import { ListItem, ListSubheader } from '@mui/material'
import { FooterContextSection } from 'PublicWebApi/Settings/types'
import { SectionLink } from '../Section/Section.styles'

interface SubSectionProps {
  section: FooterContextSection
}

const SubSection = ({ section }: SubSectionProps) => {
  return (
    <>
      <ListSubheader
        disableGutters
        disableSticky
        className="sub-header"
        sx={(theme) => ({
          ...theme.typography.subtitle2,
        })}
      >
        {section.title}
      </ListSubheader>

      {section?.children?.map((link) => (
        <ListItem key={`sectionlink-${link.title}`} alignItems="flex-start">
          <SectionLink
            data-testid={`link-with-subtitle-${link.title}`}
            url={link.url}
            text={link.title}
          />
        </ListItem>
      ))}
    </>
  )
}

export default SubSection
